import {
  PageLayout,
  PageLayoutContent,
} from "@clockwise/web-commons/src/ui/page-layout/PageLayout";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import FlexibleMeetings from "../components/flexible-meetings/FlexibleMeetings";
import FlexibleMeetingsGuidance from "../components/flexible-meetings/FlexibleMeetingsGuidance";
import { MonetizationBadge } from "../components/flexible-meetings/MonetizationBadge";
import { PageEvents, page } from "../util/analytics.util";

const FlexibleMeetingsPage = () => {
  useEffect(() => {
    page(PageEvents.FLEXIBLE_MEETINGS_PAGE);
  }, []);

  return (
    <>
      <Helmet>
        <title>Flexible meetings · Clockwise</title>
      </Helmet>
      <PageLayout
        title={
          <div className="cw-flex cw-items-center">
            Flexible meetings
            <MonetizationBadge />
          </div>
        }
        description={<FlexibleMeetingsGuidance />}
      >
        <PageLayoutContent>
          <FlexibleMeetings />
        </PageLayoutContent>
      </PageLayout>
    </>
  );
};

export default FlexibleMeetingsPage;
